var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScalpTemperatureLGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#939393",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3a4 4 0 0 1 4 4v11.529a6 6 0 1 1-8 0V6.999a4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 9.75.001 11c.725 0 1.368.343 1.78.874.294.38.469.858.469 1.376 0 .621-.252 1.184-.659 1.591-.407.407-.97.659-1.591.659a2.243 2.243 0 0 1-1.591-.659A2.243 2.243 0 0 1 13.75 23c0-.518.175-.996.47-1.376A2.244 2.244 0 0 1 16 20.75v-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10h3m-3 6h3m-3-9h2m-2 6h2",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScalpTemperatureLGray);
export default __webpack_public_path__ + "static/media/icon_scalp_temperature_l_gray.ad067e32.svg";
export { ForwardRef as ReactComponent };